import axios from 'axios';
import { baseURL, environment } from '../../../api/environment';

const URL = baseURL;

/**
 * Guarda el ID de PayPal
 */
export const saveIdPaypal = async ({ commit }, params) => {
    try {
        commit('SET_ID_PAYPAL', params);
    } catch (err) {
        commit('SET_ERROR', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Obtiene el Order ID de PayPal
 */
export const tranOrderId = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const env = environment.ENV;
        
        const endpoint = env === 'production' 
            ? 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/Prod/getorder_paypal_ecodig'
            : 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/dev/getorder_paypal_ecodig';
        
        console.log('PayPal - Ambiente:', env);
        console.log('PayPal - Endpoint:', endpoint);
        
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                "folio": params.folio,
                "monto": params.monto
            }
        });
        
        commit('SET_Order_Id', data);
        return data;
    } catch (err) {
        console.error('❌ PayPal Order ID Error:', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Registra la transacción de PayPal
 */
export const tran_paypal = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const env = environment.ENV;
        
        const endpoint = env === 'production' 
            ? 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/Prod/insertatransaccion_paypal_ecodigital'
            : 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/dev/insertatransaccion_paypal_ecodigital';
        
        console.log('PayPal - Ambiente:', env);
        console.log('PayPal - Endpoint:', endpoint);
        
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            data: {
                "folio": params.folio,
                "monto": params.monto,
                "orderIdDish": params.orderIdDish,
                "orderIdPaypal": params.orderIdPaypal,
                "estatus": params.estatus,
                "request": params.request,
                "response": params.response,
                "canalPago": params.canalPago
            }
        });
        
        commit('SET_Tran_paypal', data);
        return data;
    } catch (err) {
        console.error('❌ PayPal Transaction Error:', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
